import PartnerLandingTemplate from '../../scenes/Partners/templates/PartnerLandingTemplate';

export default PartnerLandingTemplate;
